module.exports = __webpack_public_path__ + "static/media/warning.918d9fd1.svg";